import { Avatar, Box, Button, CircularProgress, IconButton, ListItem, ListItemAvatar, ListItemText, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, useTheme } from "@mui/material";
import { DragDropContext, Draggable, Droppable, DropResult } from "react-beautiful-dnd";
import SimpleDialog from "../../common/SimpleDialog";
import { reorder } from "../helpers";
import { CadencePlaybookStep, CadenceTemplate, loadPlaybooks, PlaybookStore } from "../PlaybookStore";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { client } from "../../../utils/axios-client";
import { useEffect, useState } from "react";
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import ActivityTypeDropdown from "../../common2/Dropdowns/ActivityTypeDropdown";
import { v4 as uuid } from 'uuid';
import { isEmpty } from "lodash";
import PlaybookCadenceTemplateDropdown from "../../common2/Dropdowns/PlaybookCadenceTemplateDropdown";
import RenderIf, { ClaimType, ClaimValue } from "../../common/RenderIf";
import useAwaitableComponent from '../../../hooks/useAwaitableComponent'
import ConfirmationDialog from '../../common/ConfirmationDialog'
import { ApiResponseType } from '../../../types'
import ApplicationStore from '../../../stores/ApplicationStore'
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import CancelIcon from '@mui/icons-material/Cancel'
import EditCadenceTemplate from "../template-library/EditCadenceTemplate";
import EyeOutline from 'mdi-material-ui/EyeOutline'
import useCadenceSteps from "./cadence-steps-hooks";

type Props = {
    open: boolean,
    onClose: () => void
}


const CadenceStepsList = ({ open, onClose }: Props) => {
    const [editMode, setEditMode] = useState(false);
    const [hasError, setHasError] = useState(false);
    
    const [activityTypeId, setActivityTypeId] = useState('');
    const selectedCadence = PlaybookStore.useState(s => s.selectedCadence!);
    const { steps, isLoading, deleteCandenceStep, updateStep, updateSteps, dirty, addRow, isError, cancel, save } = useCadenceSteps(selectedCadence.id);
    const theme = useTheme();
    const playbook = PlaybookStore.useState(s => s.selectedPlaybook!);
    const [editTemplateOpen, setEditTemplateOpen] = useState(false);
    const [showVariantsOpen, setShowVariantsOpen] = useState(false);

    const [viewMode, setViewMode] = useState(false);
    //useEffect(() => {
    //    refetch();
    //}, [open])
    const [status, execute, resolve, reject, reset] = useAwaitableComponent();
    const showModal = status !== "idle";

    const handleConfirmDelete = async (row: CadencePlaybookStep) => {
        try {
            const value = await execute();
            deleteCandenceStep(row);
        } catch (err) {

        } finally {
            reset();
        }
    };


    const onDragEnd = ({ destination, source }: DropResult) => {
        // dropped outside the list
        if (!destination) return;

        const newItems = reorder(steps!, source.index, destination.index);

        updateSteps(newItems);

    };

    //const updateRowValue = async (item: CadencePlaybookStep, propName: string, newValue: string) => {
    //    const newItems = [...data!];

    //    var row = newItems.find(p => p.id == item.id)

    //    if (row) {
    //        row[propName] = newValue;

    //        queryClient.setQueryData(["cadenceSteps", selectedCadence.id], (oldData) => [...newItems]);

    //        mutate({ items: newItems });
    //    }
    //}

    //const updateRowValueInt = async (item: CadencePlaybookStep, propName: string, newValue: number) => {
    //    const newItems = [...data!];

    //    var row = newItems.find(p => p.id == item.id)

    //    if (row) {
    //        row[propName] = newValue;

    //        //            queryClient.setQueryData(["cadenceSteps", selectedCadence.id], (oldData) => [...newItems]);

    //        mutate({ items: newItems });
    //    }
    //}

    //const toggleRowValue = async (item: CadencePlaybookStep, propName: string) => {
    //    const newItems = [...data!];

    //    var row = newItems.find(p => p.id == item.id)

    //    if (row) {
    //        row[propName] = !row[propName];

    //        queryClient.setQueryData(["cadenceSteps", selectedCadence.id], (oldData) => [...newItems]);

    //        mutate({ items: newItems });
    //    }
    //}

    const onAddRow = async () => {
        setHasError(false);
        if (isEmpty(activityTypeId)) {
            setHasError(true);
            return;
        }

        addRow(activityTypeId);
    }

    const onView = async (cadenceTemplateId: string) => {
        const response = await client.get('/api/playbooks/templates', { params: { id: cadenceTemplateId } });

        PlaybookStore.update(s => {
            s.selectedTemplate = response.data;
        })

        PlaybookStore.update(s => {
            s.selectedTemplate = response.data;
        })
        setViewMode(true);
        setEditTemplateOpen(true);
    }

    const onCloseEditTemplate = () => {
        PlaybookStore.update(s => {
            s.selectedTemplate = null;
        })

        setEditTemplateOpen(false);
        setViewMode(false);
    }

    const handleSave = async () => {
        try {
            await save();
            setActivityTypeId('');
            setEditMode(false);
        }
        catch (err) {

        }        
    }

    const handleCancel = async () => {
        cancel();
        setEditMode(false);
    }


    return <SimpleDialog open={open} onClose={onClose} sx={{ minHeight: 500 }}>
        <Box sx={{ display: 'flex', justifyContent: 'right', gap: 5, alignItems: 'center' }} >
            <RenderIf claimType={ClaimType.Playbooks} claimValue={ClaimValue.AddPlaybookCadenceStep}>
                {editMode && <ActivityTypeDropdown sx={{ maxWidth: '40%' }} value={activityTypeId} onChange={(newValue) => setActivityTypeId(newValue)} error={hasError} />}
                {editMode && <Button variant="contained" size="small" onClick={onAddRow} endIcon={<AddIcon />}>Add Step</Button>}
            </RenderIf>
            <RenderIf claimType={ClaimType.Playbooks} claimValue={ClaimValue.EditPlaybookCadenceSteps}>
                {!editMode && <Button variant="contained" size="small" onClick={()=> setEditMode(true)} endIcon={<EditIcon />}>Edit</Button>}
            </RenderIf>

            {!editMode && <Button variant="contained" size="small" onClick={onClose} endIcon={<CloseIcon />}>Close</Button>}
            {editMode && <Button variant="contained" size="small" onClick={handleCancel} endIcon={<CancelIcon />}>Cancel</Button>}
            {editMode && <Button variant="contained" size="small" onClick={handleSave} endIcon={<ArrowBackIcon />}>Save</Button>}
        </Box>

        <Box sx={{ mt: 5 }}>
            <TableContainer sx={{ maxHeight: '80vh' }}>
                <Table size='small' sx={{ width: '100%' }} stickyHeader>
                    <TableHead
                        sx={{ backgroundColor: theme => (theme.palette.mode === 'light' ? 'grey.50' : 'background.default') }}
                    >
                        <TableRow>
                            <TableCell sx={{ height: '3.375rem' }}>Activity Type</TableCell>
                            <TableCell sx={{ height: '3.375rem' }}>Cadence Template</TableCell>
                            <TableCell sx={{ width: 30 }}></TableCell>
                            <TableCell sx={{ height: '3.375rem', textAlign: 'center', width: 160 }}>Auto Send</TableCell>
                            <TableCell sx={{ height: '3.375rem', textAlign: 'center', width: 160 }}>Process When</TableCell>
                            <TableCell sx={{ height: '3.375rem', textAlign: 'center', width: 80 }}>Activities</TableCell>
                            <TableCell sx={{ height: '3.375rem', textAlign: 'center', width: 60 }}>MIs</TableCell>
                            <TableCell sx={{ height: '3.375rem', textAlign: 'center', width: 60 }}>MQLs</TableCell>
                            <TableCell sx={{ height: '3.375rem', textAlign: 'center', width: 60 }}>DCs</TableCell>
                            <TableCell sx={{ height: '3.375rem', textAlign: 'center', width: 60 }}>Opportunities</TableCell>
                            <TableCell sx={{ height: '3.375rem', textAlign: 'center', width: 80 }}></TableCell>
                        </TableRow>
                    </TableHead>

                    <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="droppable-list">
                            {provided => (
                                <TableBody ref={provided.innerRef} {...provided.droppableProps} style={{ width: '100%' }}>
                                    {steps.map((item, index) => (
                                        <Draggable draggableId={item.id} index={index}>
                                            {(provided, snapshot) => (
                                                <>
                                                    <TableRow hover key={index} sx={{ '&:last-of-type td': { border: 0 }, height: 50, userSelect: 'none', WebkitUserSelect: 'none', MozUserSelect: 'none', width: '100%' }} ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}>
                                                        <TableCell>
                                                            <Box >
                                                                {!editMode && <Typography sx={{ fontWeight: 500, fontSize: '0.875rem' }}>{item.currentActivityName}</Typography>}
                                                                {editMode && <ActivityTypeDropdown value={item.currentActivityId} onChange={(newValue) => { updateStep({ ...item, currentActivityId: newValue }) }} />}
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Box >
                                                                {!editMode && <Typography sx={{ fontWeight: 500, fontSize: '0.875rem' }}>{item.cadenceTemplateName}</Typography>}
                                                                {editMode && <PlaybookCadenceTemplateDropdown playbookId={playbook.id} activityIdentifer={item.currentActivityId} value={item.cadenceTemplateId} onChange={(newValue) => { updateStep({ ...item, cadenceTemplateId: newValue }) }} />}
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell>
                                                            <IconButton size='small' component='a' sx={{ textDecoration: 'none' }} onClick={() => onView(item.cadenceTemplateId)} title={`View template: ${item.cadenceTemplateName}`}>
                                                                <EyeOutline fontSize='small' />
                                                            </IconButton>
                                                        </TableCell>
                                                        <TableCell>
                                                            {!isEmpty(item.currentActivityName) && (item.currentActivityName.toLowerCase().includes('email') || item.currentActivityName.toLowerCase().includes('sms')) &&
                                                                <Box sx={{ textAlign: 'center' }}>
                                                                    {!editMode && (item.autoSend ? 'auto send' : 'no auto send')}
                                                                    {editMode && <Switch checked={item.autoSend} onChange={() => updateStep({...item, autoSend: !item.autoSend})} />}
                                                                </Box>}
                                                        </TableCell>
                                                        <TableCell sx={{ width: 160 }} >
                                                            <Box sx={{ textAlign: 'center' }}>
                                                                {!editMode && <Typography sx={{ fontWeight: 500, fontSize: '0.875rem' }}>{item.proccessWhen}</Typography>}
                                                                {editMode && <TextField value={item.proccessWhen} type="number" size="small" onChange={(e) => updateStep({ ...item, proccessWhen: parseInt(e.target.value) })} />}
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell sx={{ width: 80 }}>
                                                            <Box sx={{ textAlign: 'center' }}>
                                                                <Typography sx={{ fontWeight: 500, fontSize: '0.875rem' }}>{item.executedCount}</Typography>
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell sx={{ width: 60 }}>
                                                            <Box sx={{ textAlign: 'center' }}>
                                                                <Typography sx={{ fontWeight: 500, fontSize: '0.875rem' }}>{item.miCount}</Typography>
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell sx={{ width: 60 }}>
                                                            <Box sx={{ textAlign: 'center' }}>
                                                                <Typography sx={{ fontWeight: 500, fontSize: '0.875rem' }}>{item.mqlCount}</Typography>
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell sx={{ width: 60 }}>
                                                            <Box sx={{ textAlign: 'center' }}>
                                                                <Typography sx={{ fontWeight: 500, fontSize: '0.875rem' }}>{item.dcCount}</Typography>
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell sx={{ width: 60 }}>
                                                            <Box sx={{ textAlign: 'center' }}>
                                                                <Typography sx={{ fontWeight: 500, fontSize: '0.875rem' }}>{item.opportunityCount}</Typography>
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell>
                                                            <RenderIf claimType={ClaimType.Playbooks} claimValue={ClaimValue.DeletePlaybookCadenceStep}>
                                                                <IconButton onClick={() => handleConfirmDelete(item)} title="Delete Cadence Step">
                                                                    <DeleteIcon fontSize='small' />
                                                                </IconButton>
                                                            </RenderIf>
                                                        </TableCell>
                                                    </TableRow>
                                                </>
                                            )}
                                        </Draggable>
                                    ))}
                                </TableBody>
                            )}
                        </Droppable>
                    </DragDropContext>
                    <TableBody>
                        {isLoading && <TableRow hover sx={{ '&:last-of-type td': { border: 0 } }}>
                            <TableCell colSpan={3} sx={{ textAlign: 'center' }}>
                                <CircularProgress />
                            </TableCell>
                        </TableRow>}

                        {!isLoading && steps && steps.length === 0 && <TableRow hover sx={{ '&:last-of-type td': { border: 0 } }}>
                            <TableCell colSpan={9} sx={{ textAlign: 'center' }}>
                                <Box>
                                    No Records Found
                                </Box>
                            </TableCell>
                        </TableRow>}

                        {isError && <TableRow hover sx={{ '&:last-of-type td': { border: 0 } }}>
                            <TableCell colSpan={3} sx={{ textAlign: 'center' }}>
                                <Box>
                                    Error Loading Steps
                                </Box>
                            </TableCell>
                        </TableRow>}

                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
        <ConfirmationDialog open={showModal} onConfirm={resolve} onCancel={reject} title="Delete?" message="Are you sure you want to delete the cadence step?" confirmButtonText="Delete" cancelButtonText="Cancel" />
        {editTemplateOpen && <EditCadenceTemplate open={editTemplateOpen} onClose={onCloseEditTemplate} viewMode={viewMode} />}
    </SimpleDialog >
}

export default CadenceStepsList;